import { UserSchema } from '@retro-ui/prisma';
import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();
const pathPrefix = '/user';

export const UserInfoSchema = z.object({
  id: UserSchema.shape.id,
  email: UserSchema.shape.email,
});
export const userContract = c.router(
  {
    fetchUsers: {
      method: 'GET',
      path: '/list',
      query: z.object({
        ids: z.array(UserSchema.shape.id),
      }),
      responses: {
        200: z.array(UserSchema),
      },
    },
    organizationUsers: {
      method: 'GET',
      path: '/organization/users',
      responses: {
        200: z.array(UserInfoSchema),
      },
    },
  },
  {
    pathPrefix,
    validateResponseOnClient: true,
  }
);
